var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "painel-divergencias az-gap-small" },
    [
      _vm.semDivergencia
        ? [
            _c(
              "div",
              {
                staticClass: "az-ds-label-sentenca painel-divergencias__titulo"
              },
              [_vm._v(" " + _vm._s(_vm.tituloConsenso) + " ")]
            ),
            _c(
              "div",
              {
                staticClass: "d-flex align-center az-gap-xsmall",
                attrs: { "data-test": "painel-divergencias-consenso" }
              },
              [
                _c("icon-svg", {
                  staticClass: "flex-shrink-0",
                  attrs: {
                    name: "check-circle",
                    size: 14,
                    color: "var(--success)"
                  }
                }),
                _c("BaseStatus", {
                  attrs: {
                    text: "",
                    "preserve-case": "",
                    content: _vm.textoConsensoDeclarado,
                    color: "success"
                  }
                })
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              {
                staticClass: "az-ds-label-sentenca painel-divergencias__titulo"
              },
              [_vm._v(" " + _vm._s(_vm.tituloDivergencia) + " ")]
            ),
            _vm.estadoInconsistente
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center az-gap-xsmall painel-divergencias__inconsistencia",
                    attrs: { "data-test": "painel-divergencias-inconsistencia" }
                  },
                  [
                    _c("icon-svg", {
                      staticClass: "flex-shrink-0",
                      attrs: {
                        name: "error-circle",
                        size: 14,
                        color: "var(--danger)"
                      }
                    }),
                    _c(
                      "span",
                      { staticClass: "az-text-secondary az-size-12" },
                      [_vm._v(_vm._s(_vm.textoEstadoInconsistente))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.divergencias, function(divergencia) {
              return _c(
                "div",
                {
                  key: divergencia.chave,
                  staticClass: "painel-divergencias__item az-gap-xsmall"
                },
                [
                  _c(
                    "div",
                    { staticClass: "az-text-primary az-size-12 font-medium" },
                    [
                      _vm._v(" " + _vm._s(divergencia.areas)),
                      divergencia.natureza
                        ? [
                            _vm._v(
                              " — natureza: " + _vm._s(divergencia.natureza)
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  divergencia.descricao
                    ? _c(
                        "div",
                        { staticClass: "az-text-secondary az-size-12" },
                        [_vm._v(" " + _vm._s(divergencia.descricao) + " ")]
                      )
                    : _vm._e(),
                  divergencia.condicao
                    ? _c(
                        "div",
                        {
                          staticClass: "az-text-secondary az-size-12 az-muted"
                        },
                        [
                          _vm._v(
                            " Cai se: " + _vm._s(divergencia.condicao) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  divergencia.caminho
                    ? _c(
                        "div",
                        {
                          staticClass: "az-text-secondary az-size-12 az-muted"
                        },
                        [
                          _vm._v(
                            " Como resolver: " +
                              _vm._s(divergencia.caminho) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }